import React from 'react';
import YepstrLogo from 'components/logos/yepstr-logo';
import styled from 'styled-components';
import Img from 'gatsby-image';
import Image from './pattern-group.svg';
import { device } from 'themes/media-queries';
import DownloadApp from 'sections/download-app';
import { useTranslation } from 'react-i18next';

const HeaderSection = props => {
  const { image } = props;
  const { t } = useTranslation();
  return (
    <Section>
      <Container>
        <Logo />
        <Title>{t('download-app.heading-alt')}</Title>
        <DownloadApp hideTitle={true} />
      </Container>
      {image && <HeaderImage fluid={image.childImageSharp.fluid} />}
    </Section>
  );
};

const Title = styled.h1`
  margin-bottom: 2rem;

  animation-name: moveInLeft;
  animation-duration: 1s;
  animation-timing-function: ease-out;

  @keyframes moveInLeft {
    0% {
      opacity: 0;
      transform: translateX(-10rem);
    }

    80% {
      transform: translateX(1rem);
    }

    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const Section = styled.header`
  grid-column: center-start / center-end;
  background-image: url(${Image});
  background-size: contain;

  @media ${device.laptop} {
    grid-column: full-start / full-end;
  }
`;

const Container = styled.div`
  position: relative;
  padding-top: 25rem;
  margin-bottom: 5rem;

  @media ${device.laptop} {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  @media ${device.mobileL} {
    padding-top: 20rem;
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

const Logo = styled(YepstrLogo)`
  position: absolute;
  top: 7.5rem;

  @media ${device.tablet} {
    left: 6rem;
  }

  @media ${device.mobileL} {
    top: 3rem;
    left: 3rem;
  }
`;

const HeaderImage = styled(Img)`
  max-height: 810px;
`;

export default HeaderSection;
